// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import createDebugger from 'debug';
const debug = createDebugger('app:components:Elevation'); // eslint-disable-line no-unused-vars
import { ThemeType } from 'trustar-2.0/types';

const getDropShadowLevel = function(level) {
  const rightShadow = `${level * 2}px`;
  const bottomShadow = `${level * 4}px`;

  return `box-shadow: 0px ${rightShadow} ${bottomShadow} 0px rgba(0,0,0.5);`;
};

// Style for Main Components (things you may export)
const StyledElevation = styled.div`
  ${({ level }) => getDropShadowLevel(level)}
  display: inline-block;
`;

const initialValues = {
  level: 0
};

// Bindings
type ElevationProps = {
  theme?: ThemeType,
  level: 0 | 1 | 2 | 3 | 4,
  children: any,
};

class Elevation extends Component {
  props: ElevationProps;
  static defaultProps = initialValues;

  //  ----Template----

  render() {
    const { ...otherProps } = this.props;

    return (
      <StyledElevation {...otherProps}>{this.props.children}</StyledElevation>
    );
  }

  // ----Methods----
}

// Logic & Helper Components

export { Elevation };



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Elevation.js